import { Trans } from '@lingui/react/macro'
import {
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable
} from '@tanstack/react-table'
import {
  Table as TableCortex,
  Td,
  THead,
  TRow,
  useDimensions
} from '@tecsinapse/cortex-react'
import React from 'react'
import { GetItemsPorPastaQuery, ItemBiblioteca } from '@/core/types/graphql'
import { rowsPerPageOptions } from '@/core/utils/rows-per-page'
import { EmptyList } from '@/core/components/empty-list'
import { Table } from '@/core/components'
import { columnsPastas } from './columns-pastas'
import { SelectedItemBiblioteca } from '@/modules/biblioteca-virtual/types/types'
import { parseAsIndex, parseAsNumberLiteral, useQueryStates } from 'nuqs'

interface TabelaPastasPropsProps {
  itemsPorPasta: GetItemsPorPastaQuery['itemsPorPasta']
  isItemSelected: (
    selectedRows: SelectedItemBiblioteca[],
    pastaId: string
  ) => boolean
  onClickItem: (item: ItemBiblioteca) => void
  onDoubleClick: (item: ItemBiblioteca) => void
  selectedRows: SelectedItemBiblioteca[]
}

export const TabelaPastas = ({
  itemsPorPasta,
  onClickItem,
  selectedRows,
  isItemSelected,
  onDoubleClick
}: TabelaPastasPropsProps) => {
  const [pagination, setPagination] = useQueryStates(
    {
      pageIndex: parseAsIndex.withDefault(0),
      pageSize: parseAsNumberLiteral(rowsPerPageOptions).withDefault(
        rowsPerPageOptions[0]
      )
    },
    { urlKeys: { pageIndex: 'page' } }
  )

  const { width } = useDimensions()
  const isMobile = width <= 768

  const table = useReactTable({
    data: (itemsPorPasta?.content ?? []) as ItemBiblioteca[],
    columns: columnsPastas({
      isItemSelected,
      onClickItem,
      selectedRows,
      isMobile
    }),
    getCoreRowModel: getCoreRowModel(),
    rowCount: itemsPorPasta?.content?.length,
    getPaginationRowModel: getPaginationRowModel(),
    onPaginationChange: setPagination,
    state: {
      pagination
    }
  })
  return (itemsPorPasta?.content ?? []).length > 0 ? (
    <TableCortex className='w-full mb-deca' data-testid='items-table'>
      <THead>
        <TRow>
          <Td colSpan={99} className={'py-centi'}>
            <div
              className={'flex w-full flex-row items-center justify-between'}
            >
              <p className='text-h3 font-bold'>
                <Trans>Pastas e Arquivos</Trans>
              </p>
            </div>
          </Td>
        </TRow>
      </THead>
      <Table.Body
        table={table}
        onDoubleClickRow={onDoubleClick}
        onClickRow={row => onClickItem(row)}
      />
      <Table.Footer
        table={table}
        rowsPerPageOptions={rowsPerPageOptions}
        loading={false}
        countList={itemsPorPasta?.content?.length ?? 0}
      />
    </TableCortex>
  ) : (
    <EmptyList />
  )
}
